<template lang='pug'>
v-autocomplete(
  v-model='model'
  :items='suggestions'
  :loading='isLoading'
  :search-input.sync='search'
  :auto-select-one-item='true'
  :disabled='disabled'
  :error='error'
  :error-messages='errorMessages'
  :no-filter='true'
  :hide-selected='true'
  :hide-no-data='true'
  :return-object='true'
  :clearable='true'
  :hint='hint'
  :persistent-hint='true'
  @change='onSelect'
  item-text='value'
  item-value='value'
  label='Введите адрес'
)
</template>

<script>
import http from '@/http'
import { debounce, get } from 'lodash'

export default {
  props: ['disabled', 'error', 'errorMessages', 'value'],

  data: () => ({
    model: null,
    search: null,
    suggestions: [],
    isLoading: false,
    hint: null
  }),

  methods: {
    async fetchSuggests(payload) {
      this.isLoading = true

      try {
        this.suggestions = (await http.post('/suggest/address', {
          query: payload,
          count: 10
        })).suggestions
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки адресов')
      }

      this.isLoading = false
    },

    async onSelect(suggestion = {}) {
      if (!suggestion.data) return

      try {
        let { suggestions } = await http.post('/suggest/address', {
          query: suggestion.value,
          count: 1
        })

        if (!suggestions.length) return

        let result = suggestions[0]
        this.hint = this.hintFromGeo(result.data)

        this.$emit('change', result)
        this.$emit('input', result.value)
      } catch (e) {
        this.$root.showSnack('Не удалось уточнить адрес')
      }
    },

    hintFromGeo({ geo_lat, geo_lon }) {
      return geo_lat && geo_lon
        ? `GPS координаты: ${geo_lat}, ${geo_lon}`
        : 'GPS координаты не определены'
    },

    debouncedFetchSuggests: debounce(function(query) {
      if (query && query !== get(this.model, 'value')) {
        this.fetchSuggests(query.trim())
      }
    }, 250)
  },

  watch: {
    search: {
      handler: 'debouncedFetchSuggests'
    },

    value(nextAddress, prevAddress) {
      if (prevAddress) return

      let model = { value: nextAddress }

      this.suggestions.push(model)
      this.model = model
    }
  }
}
</script>
